import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component, useEffect, useState } from 'react';
import { connect, ReactReduxContext } from 'react-redux';
import { AuthenticationState } from 'react-aad-msal';
import { Container, Row, Col, Button, Nav } from "react-bootstrap";
import { SideMenu } from "./SideMenu"; // Type defintitions

import * as TYPES from '../../types'; // Utilities

import * as UTIL from '../../util'; // Design System

import Logo from "../Logo";
import Modal from '../modal/Modal';
import Menu from './Menu';
import SecondaryMenu from './SecondaryMenu'; // Forms

import SearchBarForm from '../forms/SearchBar'; // Redux

import { waitlistDuck } from "../../ducks/waitlist";
import { rewardsDuck } from '../../ducks/rewards';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { withCookies, Cookies } from 'react-cookie';
import PegIcon from '../../images/svg/peg-icon.svg';
import MediaQuery from 'react-responsive';
import { getSessionStorageKey } from '../../util/sessionStorage';
import axios from 'axios';
import { loyaltyDuck } from '../../ducks/loyalty';
import { LoyaltyAccountStatus } from '../../util/LoyaltyAccountStatus';
import { wishlistDuck } from '../../ducks/wishlist';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { mobilepayDuck } from '../../ducks/mobilepay';
var waitlistOperations = waitlistDuck.operations;
var rewardsOperations = rewardsDuck.operations;
var loyaltyOperations = loyaltyDuck.operations;
var wishlistOperations = wishlistDuck.operations;
var mobilePayOperations = mobilepayDuck.operations;

var HeaderNav = /*#__PURE__*/function (_Component) {
  _inherits(HeaderNav, _Component);

  var _super = _createSuper(HeaderNav);

  // items = [];
  function HeaderNav(props) {
    var _this;

    _classCallCheck(this, HeaderNav);

    _this = _super.call(this, props);
    var cookies = props.cookies;
    _this.state = {
      modalTitle: 'Login',
      isVisible: false,
      formModalVisible: false,
      loginForm: true,
      searchActive: false,
      showPayInApp: props.showPayInApp || false,
      // MOBILE ONLY FEATURE
      hideBanner: false,
      hasInterval: (cookies === null || cookies === void 0 ? void 0 : cookies.get('hasInterval')) || false,
      releaseGoogleRwgToken: false
    };
    _this.handleLogin = _this.handleLogin.bind(_assertThisInitialized(_this));
    _this.handleLogout = _this.handleLogout.bind(_assertThisInitialized(_this));
    _this.handleShowModal = _this.handleShowModal.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleExit = _this.handleExit.bind(_assertThisInitialized(_this));
    _this.handleSidebar = _this.handleSidebar.bind(_assertThisInitialized(_this));
    _this.toggleSearch = _this.toggleSearch.bind(_assertThisInitialized(_this));
    _this.closeSearch = _this.closeSearch.bind(_assertThisInitialized(_this));
    _this.callHideBanner = _this.callHideBanner.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HeaderNav, [{
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        formModalVisible: true
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        formModalVisible: false
      });
    }
  }, {
    key: "handleExit",
    value: function handleExit() {
      this.setState({
        modalTitle: 'Login',
        loginForm: true
      });
    }
  }, {
    key: "handleLogin",
    value: function handleLogin() {
      if (typeof this.props.handleLogin === 'function') {
        return this.props.handleLogin();
      }

      return false;
    }
  }, {
    key: "handleSidebar",
    value: function handleSidebar() {
      if (typeof this.props.toggleSidenav === 'function') {
        return this.props.toggleSidenav();
      }

      return false;
    }
  }, {
    key: "handleLogout",
    value: function handleLogout() {
      var _this2 = this;

      if (typeof this.props.handleLogout === 'function') {
        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var redirectURL, queryParams;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Get the current URL
                  redirectURL = window.location.pathname; // Get the query string part of the URL

                  queryParams = window.location.search;
                  window.localStorage.setItem("LogoutRedirectUrl", redirectURL + queryParams);
                  _context.next = 5;
                  return _this2.props.resetRewardsRedemptionAction();

                case 5:
                  _context.next = 7;
                  return _this2.props.orderValidate();

                case 7:
                  _context.next = 9;
                  return _this2.props.resetAccountData();

                case 9:
                  _context.next = 11;
                  return _this2.props.clearWishlist();

                case 11:
                  _context.next = 13;
                  return _this2.props.handleLogout();

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      } else {
        return false;
      }
    }
  }, {
    key: "toggleSearch",
    value: function toggleSearch(e) {
      this.setState({
        searchActive: !this.state.searchActive
      });
    }
  }, {
    key: "closeSearch",
    value: function closeSearch(e) {
      if (this.state.searchActive) {
        this.setState({
          searchActive: false
        });
      }
    }
  }, {
    key: "callHideBanner",
    value: function callHideBanner() {
      this.setState({
        hideBanner: true
      });
    }
  }, {
    key: "createRwgCookie",
    value: function createRwgCookie(cookieName, cookieValue, expirationDays) {
      var date = new Date();
      date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + date.toUTCString();
      document.cookie = cookieName + "=" + cookieValue + "; " + expires + "; path=/;";
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state,
          _this3 = this;

      // Get the current URL
      var redirectURL = window.location.pathname; // Get the query string part of the URL

      var queryParams = window.location.search;
      window.localStorage.setItem("LoyaltyLogInRedirectUrl", redirectURL + queryParams);
      var _this$props = this.props,
          _this$props$getShopCa = _this$props.getShopCategories,
          getShopCategories = _this$props$getShopCa === void 0 ? function () {
        return console.log("getShopCategories");
      } : _this$props$getShopCa,
          cookies = _this$props.cookies;

      if (((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.hasInterval) === false && (window.location.pathname.includes('/shop') || window.location.pathname == '/')) {
        getShopCategories();
        cookies.set('hasInterval', true, {
          path: '/'
        });
        this.setState({
          hasInterval: true
        });
      }

      var interval = 14400000; // 4 hours to Milliseconds

      setInterval(function () {
        getShopCategories();
      }, interval);
      var intervalToCheckToken = 60000; // 1 min to Milliseconds

      setInterval(function () {
        var _accountState$aadResp, _accountState$aadResp2, _accountState$aadResp3;

        var currentTimestamp = Math.floor(Date.now() / 1000);
        var accountState = getSessionStorageKey('account');
        var diff = parseInt((accountState === null || accountState === void 0 ? void 0 : (_accountState$aadResp = accountState.aadResponse) === null || _accountState$aadResp === void 0 ? void 0 : (_accountState$aadResp2 = _accountState$aadResp.account) === null || _accountState$aadResp2 === void 0 ? void 0 : (_accountState$aadResp3 = _accountState$aadResp2.idTokenClaims) === null || _accountState$aadResp3 === void 0 ? void 0 : _accountState$aadResp3.exp) || 0) - currentTimestamp;

        if (diff <= 120 && diff > 0) {
          _this3.handleLogout();
        }
      }, intervalToCheckToken);

      if (this.props.authenticationState !== AuthenticationState.Authenticated) {
        this.props.resetPegPoints();
      }

      if (this.props.authenticationState === AuthenticationState.Authenticated) {
        var _sessionState$aadResp, _this$props$accountIn, _this$props$accountIn2, _this$props$accountIn3;

        var sessionState = getSessionStorageKey("account");
        var token = (sessionState === null || sessionState === void 0 ? void 0 : (_sessionState$aadResp = sessionState.aadResponse) === null || _sessionState$aadResp === void 0 ? void 0 : _sessionState$aadResp.jwtIdToken) || null;
        var apiUrl = UTIL.apiUtil.API.loyalty.getAccountDetails;
        var email = ((_this$props$accountIn = this.props.accountInfo) === null || _this$props$accountIn === void 0 ? void 0 : (_this$props$accountIn2 = _this$props$accountIn.account) === null || _this$props$accountIn2 === void 0 ? void 0 : (_this$props$accountIn3 = _this$props$accountIn2.idToken) === null || _this$props$accountIn3 === void 0 ? void 0 : _this$props$accountIn3.signInName) || null;
        var url = apiUrl.replace("{email}", email);

        if (!email || !token) {
          return;
        }

        axios({
          method: "get",
          headers: _objectSpread(_objectSpread({}, UTIL.apiUtil.setHeaders()), {}, {
            "Content-Type": "application/json",
            Authorization: "Bearer ".concat(token)
          }),
          url: url
        }).then(function (response) {
          var _response$data, _response$data$loyalt;

          var customers = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$loyalt = _response$data.loyalty) === null || _response$data$loyalt === void 0 ? void 0 : _response$data$loyalt.customers) || {};

          if (customers === null || customers === void 0 ? void 0 : customers.email) {
            var _customers$eventSumma;

            var newResponse = {
              FirstName: (customers === null || customers === void 0 ? void 0 : customers.firstName) || "",
              LastName: (customers === null || customers === void 0 ? void 0 : customers.lastName) || "",
              HomePhone: (customers === null || customers === void 0 ? void 0 : customers.mobilePhone) || (customers === null || customers === void 0 ? void 0 : customers.homePhone) || "",
              ExternalCustomerId: (customers === null || customers === void 0 ? void 0 : customers.externalCustomerId) || "",
              Balance: (customers === null || customers === void 0 ? void 0 : customers.balance) || 0,
              EnrolledAt: (customers === null || customers === void 0 ? void 0 : customers.enrolledAt) || "",
              Email: (customers === null || customers === void 0 ? void 0 : customers.email) || "",
              Birthdate: (customers === null || customers === void 0 ? void 0 : customers.birthdate) || "",
              Unsubscribed: (customers === null || customers === void 0 ? void 0 : customers.unsubscribed) ? true : false,
              Status: (customers === null || customers === void 0 ? void 0 : customers.status) || "",
              customerCoupons: (customers === null || customers === void 0 ? void 0 : customers.customerCoupons) || [],
              customerRewards: (customers === null || customers === void 0 ? void 0 : customers.customerRewards) || []
            };

            _this3.props.setLoyaltyAccountData(newResponse);

            _this3.props.setLocalPegPoints(newResponse === null || newResponse === void 0 ? void 0 : newResponse.Balance);

            _this3.props.setTransactionLimitInfo({
              transactionLimitReached: (customers === null || customers === void 0 ? void 0 : (_customers$eventSumma = customers.eventSummary) === null || _customers$eventSumma === void 0 ? void 0 : _customers$eventSumma.transactionsAllowedToEarn) > 0 ? false : true
            });
          }
        }).catch(function (error) {
          console.log("Get User Info Error", error);
        }).finally(function () {});
      }

      if (this.props.authenticationState === AuthenticationState.Authenticated) {
        var _loyaltyStorage$accou;

        var loyaltyStorage = UTIL.getLoyaltyStorage();

        if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused && window.sessionStorage.getItem("cbUserJustLoggedIn") === "true") {
          var openPegPausedModal = new CustomEvent("openPegPausedModal", {
            detail: {
              show: true
            }
          });
          setTimeout(function () {
            window.dispatchEvent(openPegPausedModal);
          });
        }
      }

      if (this.props.authenticationState === AuthenticationState.Authenticated && window.sessionStorage.getItem("cbUserJustLoggedIn") === "true") {
        this.props.getWishlist();
      }

      setTimeout(function () {
        window.sessionStorage.removeItem('cbUserJustLoggedIn');
      });

      if (UTIL.loginUrl()) {
        if (typeof this.props.handleLogin === 'function' && this.props.authenticationState !== AuthenticationState.Authenticated) {
          return this.props.handleLogin();
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      var _this$props$flags;

      if (((_this$props$flags = this.props.flags) === null || _this$props$flags === void 0 ? void 0 : _this$props$flags['releaseGoogleRwgToken']) !== this.state.releaseGoogleRwgToken) {
        var _this$props$flags2;

        this.setState({
          releaseGoogleRwgToken: (_this$props$flags2 = this.props.flags) === null || _this$props$flags2 === void 0 ? void 0 : _this$props$flags2['releaseGoogleRwgToken']
        });
      }

      if (this.state.releaseGoogleRwgToken) {
        // save rwg token cookie
        var urlParams = new URLSearchParams(window.location.search);
        var rwgToken = urlParams.get('rwg_token');

        if (rwgToken && rwgToken !== '') {
          this.createRwgCookie('rwgToken', rwgToken, 30);
        }
      }

      if (!this.state.releaseGoogleRwgToken && prevState.releaseGoogleRwgToken) {
        //remove rwgToken cookie
        document.cookie = "rwgToken" + "=; Max-Age=-99999999;";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          _this$props2$secondar = _this$props2.secondaryNavVisible,
          secondaryNavVisible = _this$props2$secondar === void 0 ? false : _this$props2$secondar,
          _this$props2$accountN = _this$props2.accountNavVisible,
          accountNavVisible = _this$props2$accountN === void 0 ? false : _this$props2$accountN,
          model = _this$props2.model,
          searchResults = _this$props2.searchResults,
          _this$props2$navigati = _this$props2.navigation,
          navigation = _this$props2$navigati === void 0 ? {} : _this$props2$navigati,
          _this$props2$hamburge = _this$props2.hamburgerMenuLinks,
          hamburgerMenuLinks = _this$props2$hamburge === void 0 ? {} : _this$props2$hamburge,
          _this$props2$hamburge2 = _this$props2.hamburgerMenuButtons,
          hamburgerMenuButtons = _this$props2$hamburge2 === void 0 ? {} : _this$props2$hamburge2,
          toggleWaitlist = _this$props2.toggleWaitlist,
          searchChangeHandler = _this$props2.searchChangeHandler,
          searchSubmitHandler = _this$props2.searchSubmitHandler,
          authenticationState = _this$props2.authenticationState,
          accountInfo = _this$props2.accountInfo,
          newItem = _this$props2.newItem,
          addTo = _this$props2.addTo,
          cart = _this$props2.cart,
          _this$props2$close = _this$props2.close,
          close = _this$props2$close === void 0 ? function () {
        return "";
      } : _this$props2$close,
          shopNav = _this$props2.shopNav,
          isCnbSite = _this$props2.isCnbSite,
          isStorePortal = _this$props2.isStorePortal,
          offlineCart = _this$props2.offlineCart;
      var value = UTIL.mapNav(shopNav) || [];
      navigation.children = navigation.children.map(function (child) {
        if (child.url === "/shop") {
          child.children = value;
        }

        return child;
      });
      var _cart$cart = cart.cart,
          reduxCart = _cart$cart === void 0 ? [] : _cart$cart;
      var _this$state2 = this.state,
          formModalVisible = _this$state2.formModalVisible,
          modalTitle = _this$state2.modalTitle,
          loginForm = _this$state2.loginForm,
          searchActive = _this$state2.searchActive,
          showPayInApp = _this$state2.showPayInApp;
      var items = navigation.children || [];

      if (isStorePortal) {
        return !UTIL.hideFooterHeader() && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
          var _this4$props, _this4$props$context, _this4$props$context$;

          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryMenu, _extends({}, _this4.props, {
            authenticationState: authenticationState,
            secondaryNavVisible: secondaryNavVisible,
            onHide: _this4.handleSidebar,
            onLogin: _this4.handleLogin,
            onLogout: _this4.handleLogout,
            handleShowSidebar: _this4.handleSidebar,
            toggleWaitlist: toggleWaitlist,
            links: hamburgerMenuLinks,
            buttons: hamburgerMenuButtons,
            model: model,
            showPayInApp: showPayInApp,
            openPayInApp: (_this4$props = _this4.props) === null || _this4$props === void 0 ? void 0 : (_this4$props$context = _this4$props.context) === null || _this4$props$context === void 0 ? void 0 : (_this4$props$context$ = _this4$props$context.props) === null || _this4$props$context$ === void 0 ? void 0 : _this4$props$context$.openPayInApp,
            isStorePortal: isStorePortal
          })), /*#__PURE__*/React.createElement(HeaderWrapper, {
            isCnbSite: isCnbSite
          }, /*#__PURE__*/React.createElement(CoreNav, {
            model: model,
            searchActive: searchActive,
            handleLogin: _this4.handleLogin,
            handleLogout: _this4.handleLogout,
            handleShowModal: _this4.handleShowModal,
            handleSidebar: _this4.handleSidebar,
            closeSearch: _this4.closeSearch,
            toggleSearch: _this4.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            items: items,
            cartLength: offlineCart.length,
            isCnbSite: isCnbSite,
            isStorePortal: isStorePortal,
            loyaltyData: _this4.props.loyalty
          }), /*#__PURE__*/React.createElement(MobileSidebar, {
            searchActive: searchActive,
            handleLogin: _this4.handleLogin,
            handleLogout: _this4.handleLogout,
            handleShowModal: _this4.handleShowModal,
            handleShowSidebar: _this4.handleSidebar,
            closeSearch: _this4.closeSearch,
            displaySearch: _this4.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            cartLength: offlineCart.length,
            isCnbSite: isCnbSite,
            isStorePortal: isStorePortal,
            pegCounterData: model,
            loyaltyData: _this4.props.loyalty
          })));
        }.bind(this));
      }

      if (isCnbSite) {
        return !UTIL.hideFooterHeader() && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
          var _this4$props2, _this4$props2$context, _this4$props2$context2;

          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryMenu, _extends({}, _this4.props, {
            authenticationState: authenticationState,
            secondaryNavVisible: secondaryNavVisible,
            onHide: _this4.handleSidebar,
            onLogin: _this4.handleLogin,
            onLogout: _this4.handleLogout,
            handleShowSidebar: _this4.handleSidebar,
            toggleWaitlist: toggleWaitlist,
            links: hamburgerMenuLinks,
            buttons: hamburgerMenuButtons,
            model: model,
            showPayInApp: showPayInApp,
            openPayInApp: (_this4$props2 = _this4.props) === null || _this4$props2 === void 0 ? void 0 : (_this4$props2$context = _this4$props2.context) === null || _this4$props2$context === void 0 ? void 0 : (_this4$props2$context2 = _this4$props2$context.props) === null || _this4$props2$context2 === void 0 ? void 0 : _this4$props2$context2.openPayInApp
          })), /*#__PURE__*/React.createElement(HeaderWrapper, {
            isCnbSite: isCnbSite
          }, /*#__PURE__*/React.createElement(CoreNav, {
            model: model,
            searchActive: searchActive,
            handleLogin: _this4.handleLogin,
            handleShowModal: _this4.handleShowModal,
            handleSidebar: _this4.handleSidebar,
            closeSearch: _this4.closeSearch,
            toggleSearch: _this4.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            items: items,
            cartLength: reduxCart.length,
            isCnbSite: isCnbSite,
            loyaltyData: _this4.props.loyalty
          }), /*#__PURE__*/React.createElement(MobileSidebar, {
            searchActive: searchActive,
            handleLogin: _this4.handleLogin,
            handleShowModal: _this4.handleShowModal,
            handleShowSidebar: _this4.handleSidebar,
            closeSearch: _this4.closeSearch,
            displaySearch: _this4.toggleSearch,
            authenticationState: authenticationState,
            accountInfo: accountInfo,
            cartLength: reduxCart.length,
            isCnbSite: isCnbSite,
            pegCounterData: model,
            loyaltyData: _this4.props.loyalty
          })));
        }.bind(this));
      }

      return !UTIL.hideFooterHeader() && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
        var _this4$props3, _this4$props3$context, _this4$props3$context2, _this4$props4, _this4$props4$context, _this4$props4$context2;

        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SecondaryMenu, _extends({}, _this4.props, {
          store: _this4.props.store,
          authenticationState: authenticationState,
          secondaryNavVisible: secondaryNavVisible,
          onHide: _this4.handleSidebar,
          onLogin: _this4.handleLogin,
          onLogout: _this4.handleLogout,
          handleShowSidebar: _this4.handleSidebar,
          toggleWaitlist: toggleWaitlist,
          links: hamburgerMenuLinks,
          buttons: hamburgerMenuButtons,
          model: model,
          showPayInApp: showPayInApp,
          openPayInApp: (_this4$props3 = _this4.props) === null || _this4$props3 === void 0 ? void 0 : (_this4$props3$context = _this4$props3.context) === null || _this4$props3$context === void 0 ? void 0 : (_this4$props3$context2 = _this4$props3$context.props) === null || _this4$props3$context2 === void 0 ? void 0 : _this4$props3$context2.openPayInApp
        })), /*#__PURE__*/React.createElement(HeaderWrapper, {
          isCnbSite: isCnbSite
        }, /*#__PURE__*/React.createElement(CoreNav, {
          model: model,
          searchActive: searchActive,
          handleLogin: _this4.handleLogin,
          handleShowModal: _this4.handleShowModal,
          handleSidebar: _this4.handleSidebar,
          closeSearch: _this4.closeSearch,
          toggleSearch: _this4.toggleSearch,
          authenticationState: authenticationState,
          accountInfo: accountInfo,
          items: items,
          cartLength: reduxCart.length,
          loyaltyData: _this4.props.loyalty
        }), /*#__PURE__*/React.createElement(SearchBar, {
          searchActive: _this4.state.searchActive,
          searchChangeHandler: searchChangeHandler,
          searchResults: searchResults
        }), /*#__PURE__*/React.createElement(MobileSidebar, {
          searchActive: searchActive,
          handleLogin: _this4.handleLogin,
          handleShowModal: _this4.handleShowModal,
          handleShowSidebar: _this4.handleSidebar,
          closeSearch: _this4.closeSearch,
          displaySearch: _this4.toggleSearch,
          authenticationState: authenticationState,
          accountInfo: accountInfo,
          cartLength: reduxCart.length,
          pegCounterData: model,
          loyaltyData: _this4.props.loyalty
        })), /*#__PURE__*/React.createElement(BannerCopy, {
          callHideBanner: _this4.callHideBanner,
          hideBanner: _this4.state.hideBanner,
          bannerModel: (_this4$props4 = _this4.props) === null || _this4$props4 === void 0 ? void 0 : (_this4$props4$context = _this4$props4.context) === null || _this4$props4$context === void 0 ? void 0 : (_this4$props4$context2 = _this4$props4$context.fields) === null || _this4$props4$context2 === void 0 ? void 0 : _this4$props4$context2.bannerCopy
        }));
      }.bind(this));
    }
  }]);

  return HeaderNav;
}(Component);

;

var mapStateToProps = function mapStateToProps(state) {
  return _objectSpread({}, state);
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    toggleWaitlist: function toggleWaitlist() {
      return dispatch(waitlistOperations.toggleWaitlist());
    },
    resetPegPoints: function resetPegPoints() {
      return dispatch(rewardsOperations.handleResetPegPoints());
    },
    setLoyaltyAccountData: function setLoyaltyAccountData(accountInfo) {
      return dispatch(loyaltyOperations.setLoyaltyAccountData(accountInfo));
    },
    setLocalPegPoints: function setLocalPegPoints(points) {
      return dispatch(rewardsOperations.handleSetLocalPegPoints(points));
    },
    resetAccountData: function resetAccountData() {
      return dispatch(loyaltyOperations.resetAccountData());
    },
    resetRewardsRedemptionAction: function resetRewardsRedemptionAction() {
      return dispatch(rewardsOperations.resetRewardsRedemptionAction());
    },
    orderValidate: function orderValidate() {
      return dispatch(mobilePayOperations.handleOrderValidate());
    },
    clearWishlist: function clearWishlist() {
      return dispatch(wishlistOperations.clearWishlist());
    },
    getWishlist: function getWishlist() {
      return dispatch(wishlistOperations.handleGetWishlist());
    },
    setTransactionLimitInfo: function setTransactionLimitInfo(info) {
      return dispatch(loyaltyOperations.setTransactionLimitInfo(info));
    }
  };
};

var EnhancedHeaderNav = connect(mapStateToProps, mapDispatchToProps)(HeaderNav);
export default withLDConsumer()(EnhancedHeaderNav);
export { SecondaryMenu };
export var BannerCopy = function BannerCopy(props) {
  var _bannerModel$jss;

  var hideBanner = props.hideBanner,
      bannerModel = props.bannerModel,
      callHideBanner = props.callHideBanner;
  var bannerText = bannerModel ? bannerModel === null || bannerModel === void 0 ? void 0 : (_bannerModel$jss = bannerModel.jss) === null || _bannerModel$jss === void 0 ? void 0 : _bannerModel$jss.value : 'Banner text not found';
  return /*#__PURE__*/React.createElement(React.Fragment, null, bannerText !== "" && bannerText && /*#__PURE__*/React.createElement("div", {
    id: "RSAlert",
    class: "RSAlert-light ".concat(hideBanner && "inactive")
  }, /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: bannerText
    },
    tag: "span"
  }), /*#__PURE__*/React.createElement("button", {
    className: "closeRSAlert",
    onClick: callHideBanner
  }, "\u2715")));
};
export var CoreNav = function CoreNav(props) {
  var _model$pegPointLinkNo, _model$pegPointLinkNo2, _model$pegPointLinkLo, _model$pegPointLinkLo2, _model$pegPointAlt, _model$pegIconAlt, _model$pegIconAlt2;

  var model = props.model,
      searchActive = props.searchActive,
      handleShowModal = props.handleShowModal,
      handleLogin = props.handleLogin,
      handleSidebar = props.handleSidebar,
      closeSearch = props.closeSearch,
      toggleSearch = props.toggleSearch,
      authenticationState = props.authenticationState,
      accountInfo = props.accountInfo,
      items = props.items,
      cartLength = props.cartLength,
      isCnbSite = props.isCnbSite,
      isStorePortal = props.isStorePortal;
  var hideCleanedItem = UTIL.cleanObject(items, 'hideInNavigation');
  var cleanedItem = UTIL.cleanTitleObject(hideCleanedItem, 'navigationTitle');

  var _useState = useState('0'),
      _useState2 = _slicedToArray(_useState, 2),
      pegPoints = _useState2[0],
      setPegPoints = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pausedAccount = _useState4[0],
      setPausedAccount = _useState4[1];

  var loyaltyStorage = UTIL.getLoyaltyStorage();
  useEffect(function () {
    var _loyaltyStorage$accou2;

    if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.Balance) && authenticationState === 'Authenticated') {
      setPegPoints(loyaltyStorage.account.Balance);
    }

    if (authenticationState === AuthenticationState.Authenticated) {
      var _loyaltyStorage$accou3;

      if ((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.Status) === LoyaltyAccountStatus.Paused) {
        setPausedAccount(true);
      }
    }

    window.addEventListener("customEventSetLoyaltyAccountData", function (e) {
      var _e$detail, _e$detail$account;

      var Balance = (e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : (_e$detail$account = _e$detail.account) === null || _e$detail$account === void 0 ? void 0 : _e$detail$account.Balance) || null;

      if (Balance) {
        setPegPoints(Balance);
      }
    });
    return function () {
      window.removeEventListener("customEventSetLoyaltyAccountData", function () {});
    };
  }, []);
  useEffect(function () {
    var _props$loyaltyData, _props$loyaltyData$ac;

    if (props.loyaltyData && ((_props$loyaltyData = props.loyaltyData) === null || _props$loyaltyData === void 0 ? void 0 : (_props$loyaltyData$ac = _props$loyaltyData.account) === null || _props$loyaltyData$ac === void 0 ? void 0 : _props$loyaltyData$ac.Balance) !== pegPoints && authenticationState === AuthenticationState.Authenticated) {
      var _props$loyaltyData2, _props$loyaltyData2$a;

      setPegPoints((_props$loyaltyData2 = props.loyaltyData) === null || _props$loyaltyData2 === void 0 ? void 0 : (_props$loyaltyData2$a = _props$loyaltyData2.account) === null || _props$loyaltyData2$a === void 0 ? void 0 : _props$loyaltyData2$a.Balance);
    }

    if (authenticationState !== AuthenticationState.Authenticated) {
      setPegPoints(0);
    }
  }, [props.loyaltyData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    className: "align-self-center cb-header--proverride cb-header__logo-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-header__logo--lg ".concat(isCnbSite ? "cnb-logo" : "")
  }, /*#__PURE__*/React.createElement(Logo, {
    model: model
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 900
  }, /*#__PURE__*/React.createElement("a", {
    href: authenticationState !== AuthenticationState.Authenticated ? (model === null || model === void 0 ? void 0 : (_model$pegPointLinkNo = model.pegPointLinkNotLoggedIn) === null || _model$pegPointLinkNo === void 0 ? void 0 : (_model$pegPointLinkNo2 = _model$pegPointLinkNo.value) === null || _model$pegPointLinkNo2 === void 0 ? void 0 : _model$pegPointLinkNo2.href) || '#' : (model === null || model === void 0 ? void 0 : (_model$pegPointLinkLo = model.pegPointLinkLoggedIn) === null || _model$pegPointLinkLo === void 0 ? void 0 : (_model$pegPointLinkLo2 = _model$pegPointLinkLo.value) === null || _model$pegPointLinkLo2 === void 0 ? void 0 : _model$pegPointLinkLo2.href) || '#',
    "aria-label": pausedAccount ? "".concat(pegPoints, " Pegs. Currently unavailable for redemption.") : '',
    className: "cb-header__peg-counter ".concat(pausedAccount ? 'cb-header__peg-counter--disabled' : '')
  }, /*#__PURE__*/React.createElement("span", {
    title: model === null || model === void 0 ? void 0 : (_model$pegPointAlt = model.pegPointAlt) === null || _model$pegPointAlt === void 0 ? void 0 : _model$pegPointAlt.value,
    className: 'cb-header__peg-counter__text'
  }, pegPoints), /*#__PURE__*/React.createElement("img", {
    className: 'cb-header__peg-counter__icon',
    src: PegIcon,
    alt: model === null || model === void 0 ? void 0 : (_model$pegIconAlt = model.pegIconAlt) === null || _model$pegIconAlt === void 0 ? void 0 : _model$pegIconAlt.value,
    title: model === null || model === void 0 ? void 0 : (_model$pegIconAlt2 = model.pegIconAlt) === null || _model$pegIconAlt2 === void 0 ? void 0 : _model$pegIconAlt2.value
  })))), /*#__PURE__*/React.createElement(Col, {
    sm: "6",
    xs: "6",
    className: "justify-content-end align-self-center d-flex d-sm-none cb-header__mobiledisplay"
  }, /*#__PURE__*/React.createElement(Nav, {
    as: "ul",
    className: "cb-header__navbar-secondary"
  }, /*#__PURE__*/React.createElement(SideMenu, {
    searchActive: searchActive,
    mobile: true,
    handleShowModal: handleShowModal,
    handleLogin: handleLogin,
    handleShowSidebar: handleSidebar,
    closeSearch: closeSearch,
    displaySearch: toggleSearch,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    cartLength: cartLength,
    isCnbSite: isCnbSite,
    isStorePortal: isStorePortal,
    pegCounterData: model,
    loyaltyData: props.loyaltyData
  }))), /*#__PURE__*/React.createElement(Col, {
    className: "cb-header__navbar-container align-self-center cb-header--poverride"
  }, /*#__PURE__*/React.createElement(Menu, {
    items: cleanedItem,
    handleLogin: handleLogin,
    handleShowModal: handleShowModal,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    isCnbSite: isCnbSite
  })));
};
export var SearchBar = function SearchBar(_ref2) {
  var searchActive = _ref2.searchActive,
      searchChangeHandler = _ref2.searchChangeHandler,
      searchSubmitHandler = _ref2.searchSubmitHandler,
      searchResults = _ref2.searchResults;
  return /*#__PURE__*/React.createElement(Col, {
    className: "cb-header__search align-self-center"
  }, /*#__PURE__*/React.createElement(SearchBarForm, {
    className: searchActive ? 'is-active' : '',
    changeHandler: searchChangeHandler,
    submitHandler: searchSubmitHandler,
    results: searchResults
  }));
};
export var MobileSidebar = function MobileSidebar(props) {
  var searchActive = props.searchActive,
      handleLogin = props.handleLogin,
      handleShowModal = props.handleShowModal,
      handleShowSidebar = props.handleShowSidebar,
      closeSearch = props.closeSearch,
      authenticationState = props.authenticationState,
      accountInfo = props.accountInfo,
      toggleSearch = props.toggleSearch,
      cartLength = props.cartLength,
      isCnbSite = props.isCnbSite,
      isStorePortal = props.isStorePortal,
      pegCounterData = props.pegCounterData;
  return /*#__PURE__*/React.createElement(Col, {
    className: "align-self-center cb-header__sideMenu ".concat(isCnbSite ? "cnb-nav-btn-wrapper" : "")
  }, /*#__PURE__*/React.createElement(SideMenu, {
    searchActive: searchActive,
    mobile: false,
    handleLogin: handleLogin,
    handleShowModal: handleShowModal,
    handleShowSidebar: handleShowSidebar,
    closeSearch: closeSearch,
    authenticationState: authenticationState,
    accountInfo: accountInfo,
    displaySearch: toggleSearch,
    cartLength: cartLength,
    isCnbSite: isCnbSite,
    isStorePortal: isStorePortal,
    pegCounterData: pegCounterData,
    loyaltyData: props.loyaltyData
  }));
};
export var HeaderWrapper = function HeaderWrapper(_ref3) {
  var children = _ref3.children,
      isCnbSite = _ref3.isCnbSite;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-header a cb-bg-clay-wood"
  }, /*#__PURE__*/React.createElement(Container, {
    className: "cb-header__container d-flex h-100"
  }, /*#__PURE__*/React.createElement(Row, {
    className: " ".concat(isCnbSite ? "justify-content-start" : "justify-content-center")
  }, children)));
};